import React from 'react';
import { useTranslation } from 'react-i18next';

const Copyright: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center px-6 text-[#333] md:pt-10 pt-[73px] md:h-[500px] h-auto">
            <h1 className="md:text-5xl text-4xl md:text-6xl font-light mb-10">{t('legal.copyright.title')}</h1>
            <div className="text-left text-[17px]">
                <h2 className="text-sm font-semibold mb-4">{t('legal.copyright.noticeTitle')}</h2>
                <p className="mb-4">
                    {t('legal.copyright.body1')}
                </p>
                <p className="mb-4">
                    {t('legal.copyright.body2')}
                </p>
                <p className="mb-6">
                    {t('legal.copyright.body3')}
                </p>

                <button className="w-full md:w-auto border border-[#3A57FF] px-6 py-2 rounded-lg text-sm hover:bg-[#3A57FF] hover:text-white transition-all">
                    {t('legal.copyright.contactCta')}
                </button>
            </div>
        </div>
    );
};

export default Copyright;
